// ************************************ Data ************************************

import { useOrganization } from "../hooks/entities/useOrganization";

const DEFAULT_CURRENCY = "SEK";

const currencies: CurrencyItemType[] = [
    { currency: "SEK", short: "kr", number: 752 },
    { currency: "NOK", short: "kr", number: 578 },
    { currency: "EUR", short: "€", number: 978 },
];

// ###############################################################################################################
// Annonspaket
const adPackages: AdPackageType[] = [
    { id: "small", name: "Litet", exposures: "30 000", price: "7 500 kr" },
    { id: "medium", name: "Mellan", exposures: "75 000", price: "15 000 kr" },
    { id: "large", name: "Stort", exposures: "150 000", price: "fr. 35 000 kr" },
]

// Pro prenumeration
const pro_yearly_price: PriceType[] = [
    { price: 499, currency: "SEK", },
    { price: 499, currency: "NOK", },
    { price: 49, currency: "EUR", },
];
//
const assortment_month_price: PriceType[] = [
    { price: 3, currency: "SEK", },
    { price: 3, currency: "NOK", },
    { price: 0.3, currency: "EUR", }
];
const price_per_boost_day: PriceType[] = [
    { price: 20, currency: "SEK", },
    { price: 20, currency: "NOK", },
    { price: 2, currency: "EUR", }
];

// ###############################################################################################################

// ************************************ Hook ************************************
export const usePricing = () => {

    const billingCurrency = useOrganization()?.currentOrganization?.billingCurrency;
    const currency = !!billingCurrency ? billingCurrency : DEFAULT_CURRENCY;

    // Formatting
    const getPriceString = (e: PriceType) => {

        const currencyFirst = (e.currency === "GBP");

        if (currencyFirst) {
            return currencies.find(m => m.currency == e.currency)?.short + " " + (Math.round(100 * e.price) / 100).toFixed(2);
        } else {
            return (Math.round(100 * e.price) / 100).toFixed(2) + " " + currencies.find(m => m.currency == e.currency)?.short;
        }
    }

    // Localized....
    const pro_yearly_price_localized = pro_yearly_price.find(m => m.currency === currency) as PriceType;
    const assortment_month_price_localized = assortment_month_price.find(m => m.currency === currency) as PriceType;
    const price_per_boost_day_localized = price_per_boost_day.find(m => m.currency === currency) as PriceType;

    return {
        // func
        getPriceString: getPriceString,

        // localized
        pro_yearly_price: pro_yearly_price_localized,
        proYearlyPriceString: getPriceString(pro_yearly_price_localized),
        price_per_boost_day: price_per_boost_day_localized,

        // Packages
        adPackages: adPackages,

        productsPrice: {
            assortment_month_price: assortment_month_price_localized,
        },

        assortmentPlantsMonthPriceString: (numberOfPlants: number) => {
            return getPriceString({
                ...assortment_month_price_localized,
                price: assortment_month_price_localized.price * numberOfPlants
            });
        },
        costForBoostDays: (numberfDays: number): string => {
            return getPriceString({
                ...price_per_boost_day_localized,
                price: price_per_boost_day_localized.price * numberfDays
            });
        }
    }
}

// *********************** Types ***********************
type CurrencyKeyType = "SEK" | "EUR" | "NOK" | "GBP";
type PriceType = {
    price: number
    currency: CurrencyKeyType
}
type CurrencyItemType = {
    currency: CurrencyKeyType,
    short: string
    number: number
}
export type AdPackageType = {
    id: "small" | "medium" | "large",
    name: string,
    price: string
    exposures: string
}